import React from 'react';
import { SelectChangeEvent } from '@mui/material';
import FacilitySelector from 'components/FacilitySelector/FacilitySelector';
import { facilityDisplayName } from 'utils/campusLabels';

export const ALL_CAMPUS_FACILITIES = 'all';

/** The filter's controlled state, as a parent hands it to a modal. */
export interface DestinationFacilityFilterProps {
  facilities: Array<{ facilityId: string; facilityName: string; facilityAlias?: string | null }>;
  /** A facility id, or ALL_CAMPUS_FACILITIES. */
  value: string;
  onChange: (value: string) => void;
}

interface DestinationFacilityFilterComponentProps extends DestinationFacilityFilterProps {
  disabled?: boolean;
}

/** Move-modal destination facility dropdown ("All campus facilities" by default); hidden for one facility. */
const DestinationFacilityFilter: React.FC<DestinationFacilityFilterComponentProps> = ({
  facilities,
  value,
  onChange,
  disabled = false
}) => {
  if (facilities.length <= 1) return null;

  return (
    <div className="mb-4">
      <FacilitySelector
        facilities={facilities.map((f) => ({
          id: f.facilityId,
          name: facilityDisplayName({ name: f.facilityName, facility_alias: f.facilityAlias })
        }))}
        value={value}
        onChange={(event: SelectChangeEvent<any>) => onChange(String(event.target.value))}
        label="Destination Facility"
        allOption={{ value: ALL_CAMPUS_FACILITIES, label: 'All campus facilities' }}
        fullWidth
        disabled={disabled}
        sx={{ width: '100%' }}
      />
    </div>
  );
};

/** True when a destination belongs to the facility the filter is set to. */
export function matchesFacilityFilter(
  item: { facilityId?: string },
  filter: string
): boolean {
  return (
    filter === ALL_CAMPUS_FACILITIES || !item.facilityId || item.facilityId === filter
  );
}

export default DestinationFacilityFilter;
